<template>
  <ContainerWrapper class="OffersList">
    <h2 v-if="title" class="section-title">{{ title }}</h2>
    <p v-if="description" class="section-description">{{ description }}</p>
    <div class="offers-card-list">
      <slot name="start-offers" />
      <OfferCardTemplateMethodContainer
        v-for="(offer, index) in offerList"
        :key="offer.offer_id || offer.cold_offer_id || offer.id || index"
        v-bind="$attrs"
        :offer="offer"
      />
      <slot />
    </div>
  </ContainerWrapper>
</template>
<script>
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OfferCardTemplateMethodContainer from '@/containers/loans/OfferCardTemplateMethodContainer.vue'
export default {
  name: 'OffersList',
  components: {
    ContainerWrapper,
    OfferCardTemplateMethodContainer,
  },
  props: {
    offerList: { type: [Array, Object], default: () => [] },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
}
</script>
<style lang="scss">
.OffersList {
  padding: 24px 0 0 0;

  & > .section-title {
    @include subtitle-1;
    color: $color-black-high;
    margin: 0 0 16px 0;
  }

  & > .section-description {
    @include body-2;
    color: $color-black-medium;
    margin: 0 0 16px 0;
  }

  .offers-card-list {
    display: grid;
    gap: 16px;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);

    @include media(sm) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media(lg) {
      grid-template-columns: repeat(3, 1fr);
    }

    @include media(xl) {
      grid-template-columns: repeat(4, 1fr);
    }

    & > div {
      min-width: auto;
      width: 100%;
    }
  }

  .flip-list-move {
    transition: transform 0.8s ease;
  }

  @keyframes shake {
    0% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0);
    }
  }
}
</style>
